export default {"src":"/_next/static/image/public/images/Info.207e4a2c93e3ec3f4067f1b463677886.svg","height":24,"width":25};